import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useState } from 'react';
import { useStyles } from './accordionContent.jss';

const AccordionContent = ({ data: { title, desc } }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const onChange = (_, value) => {
    setExpanded(value);
  };

  return (
    <Accordion classes={{ root: classes.accorditionRoot }} onChange={onChange} square={true}>
      <AccordionSummary
        classes={{
          root: classes.accorditionSummaryRoot,
          expanded: classes.expanded
        }}
        expandIcon={
          <ExpandMoreIcon
            className={[
              (classes.icon,
              {
                [classes.iconActive]: expanded
              })
            ]}
          />
        }
      >
        <Typography variant="h4" classes={{ root: classes.title }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2">{desc}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionContent;
